"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var ProductPrice = /** @class */ (function (_super) {
    __extends(ProductPrice, _super);
    function ProductPrice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductPrice.prototype.render = function () {
        var _a = this.props, variant = _a.variant, showDiscount = _a.showDiscount, showCurrency = _a.showCurrency, moneyFormat = _a.moneyFormat, moneyFormatCurrency = _a.moneyFormatCurrency, layout = _a.layout, collectionThumb = _a.collectionThumb;
        var onSale = variant.compare_at_price > variant.price;
        var price = variant.price;
        var compare_at_price = variant.compare_at_price;
        if (collectionThumb) {
            price = price * 100;
        }
        if (collectionThumb) {
            compare_at_price = compare_at_price * 100;
        }
        return layout === "collection" ? (React.createElement("div", { className: this.props.className }, this.props.showUnavailable && !variant.available && !this.props.isPreorder ? (React.createElement("p", null, this.props.data ? this.props.data.locales.global.cart.sold_out : "Sold Out")) : (React.createElement(React.Fragment, null,
            React.createElement("p", { className: " " + (this.props.inline && this.props.inline ? "flex flex-row items-center" : "") },
                React.createElement("span", { className: "inline-block text-xmd font-semibold align-middle money " + (onSale ? " text-red" : "") }, next_components_1.ShopifyNext.Utils.formatMoney(price, showCurrency ? moneyFormatCurrency : moneyFormat)),
                onSale ? (React.createElement("span", { className: "inline-block text-xs align-middle text-grey-dark money pl-0-8" },
                    React.createElement("span", null, next_components_1.ShopifyNext.Utils.formatMoney(compare_at_price, moneyFormat)))) : null),
            this.props.isPreorder ? (React.createElement("p", { className: "discount opacity-75 pt-1" }, this.props.data ? this.props.data.locales.global.cart.preorder : "")) : null)))) : (React.createElement("div", { className: this.props.className },
            React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    React.createElement("span", { className: "inline-block align-middle money " + (onSale ? "text-red" : "") }, next_components_1.ShopifyNext.Utils.formatMoney(price, showCurrency ? moneyFormatCurrency : moneyFormat)),
                    onSale ? (React.createElement("span", { className: "inline-block align-middle money pl-0-8 text-xs text-grey-dark" }, next_components_1.ShopifyNext.Utils.formatMoney(compare_at_price, moneyFormat))) : null))));
    };
    return ProductPrice;
}(React.PureComponent));
exports.ProductPrice = ProductPrice;
